import React from 'react'
import { useHistory } from 'react-router-dom'
import Chart from './chart/chart'
import classes from './stock.module.scss';
import { cn } from '../../utils/cn'
import { RotateCw, X } from 'lucide-react'

const Stock = ({ ticker, onRemove, onRetry, data, status = 'available' }) => {
  const { push } = useHistory();

  const acc = React.useMemo(
    () => Number.isFinite(data?.info?.metrics?.daily_accuracy) ?
      Math.round((data?.info?.metrics?.daily_accuracy) * 100) : undefined,
    [data],
  );

  const onClick = React.useCallback(() => {
    push(`/cabinet/stock/${data?.info?.ticker}`);
  }, [data, push]);
  
  return (
    <div className={cn('ui-state-default box ui-sortable-handle', classes.wrapper)}>
      <button
        type="button"
        aria-label={`Remove ${ticker}`}
        title={`Remove ${ticker}`}
        className={classes.link}
        onClick={() => onRemove(ticker)}
      >
        <X size={18} aria-hidden="true" />
      </button>
      <div className="stockBg">
        <p className={classes.header} onClick={status === 'available' ? onClick : undefined}>
          {data?.info?.name}
          <br/>
          {ticker}
        </p>
        {status !== 'available' ? (
          <div className={classes.unavailable} role="status">
            <span>{status === 'loading' ? 'Loading chart...' : 'Chart unavailable'}</span>
            {status === 'unavailable' && (
              <button type="button" onClick={() => onRetry(ticker)} aria-label={`Retry ${ticker}`}>
                <RotateCw size={16} aria-hidden="true" /> Retry
              </button>
            )}
          </div>
        ) : <>
        <Chart
          close={data?.close}
          prediction={data?.prediction}
        />
        {acc !== undefined && (
          <h6>
            Accuracy: {acc}%
          </h6>
        )}
        </>}
      </div>
    </div>
  );
};

export default Stock;
